export class Adapter {
    /**
     * @param dialog {Dialog}
     * @param options {DialogOptions}
     */
    constructor(dialog, options) {
        /** @type {Dialog} */
        this.dialog = dialog;
        this.loop = 'loop' in options ? options.loop : true;
        /** @type {AdapterItem[]} */
        this._elements = [];
    }

    /**
     * @param currentIndex {number}
     * @returns {number|null}
     */
    nextIndex(currentIndex) {
        if (this.loop) {
            return (currentIndex + 1) % this._elements.length;
        }
        return currentIndex + 1 < this._elements.length ? currentIndex + 1 : null;
    }

    /**
     * @param currentIndex {number}
     * @returns {number|null}
     */
    prevIndex(currentIndex) {
        if (this.loop) {
            return (currentIndex - 1 + this._elements.length) % this._elements.length;
        }
        return currentIndex - 1 >= 0 ? currentIndex - 1 : null;
    }

    /**
     * @param currentIndex {number}
     * @returns {boolean}
     */
    hasNext(currentIndex) {
        return this.loop || currentIndex < this._elements.length - 1;
    }

    /**
     * @param currentIndex {number}
     * @returns {boolean}
     */
    hasPrev(currentIndex) {
        return this.loop || currentIndex > 0;
    }

    /**
     * @param index {number}
     * @returns {AdapterItem}
     */
    getForIndex(index) {
        return this._elements[index];
    }
}
